import { Box } from '@chakra-ui/react';

export default function MapWithBottombarLayout({
    mapComponent,
    bottombarComponent,
}) {
    return (
        <Box bg='gray.100' width='100%' height='100%'>
            {/* Map full screen */}
            <Box
                position="relative"
                flex={{ md: 1, sm: 1, lg: 2 }}
                style={{ height: '100vh' }}
                p="2"
                shadow="sm"
                borderRadius="4"
            >
                {mapComponent}
            </Box>

            {/* Bottom bar */}
            <Box
                position='relative'
                width="90vw"
                left="50%"
                transform="translateX(-50%)"
                bg="white"
                zIndex="overlay"
                borderRadius="lg"
                marginTop="-40vh"  // Pull the bar up to make 30vh visible
                boxShadow="md"
                shadow="md"
                shadowColor="gray.500"
                minHeight='400px'
            >
                {bottombarComponent}
            </Box>

            <Box height='15px' /> {/* Janky padding */}
        </Box>
    );
}